module.exports = __webpack_public_path__ + "img/hotel-med.c54c1ca2.jpg";